import type React from 'react'
import type { IconProps } from './types'

const ArrowLeftIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M20 13L7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11L20 11L20 13Z' />
	</svg>
)

export default ArrowLeftIcon
